import dbw from '@/worker/dbw';

export class DbRef {
	public id: number;
	constructor(id: number) {
		this.id = id;
	}
	public async getCards() {
		return await dbw.getCardsByHead(this.id);
	}
	/**
	 * Execute a raw SQL query against the table
	 * Use {table} as placeholder for the table name
	 * Use {where} as placeholder for the current filter WHERE clause
	 * @example
	 * const result = await head.rawQuery(`
	 *   SELECT "CODE", SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total
	 *   FROM {table}
	 *   {where}
	 *   GROUP BY "CODE"
	 * `);
	 */
	public async rawQuery(sql: string) {
		return await dbw.rawQuery(this.id, sql);
	}
}
